export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d2849d89fb2bcc7e53a4d42f0cdeee32.jpg"
          alt="Business Turnaround Consulting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="inline-flex items-center gap-2 bg-teal-500/20 border border-teal-500/40 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 bg-teal-400 rounded-full"></span>
              <span className="text-teal-300 text-sm font-medium">
                Business Turnaround Specialists
              </span>
            </div>

            <h2 className="text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6">
              We Help Revive Corporations
            </h2>

            <p className="text-lg text-gray-300 mb-8 leading-relaxed max-w-xl">
              Revivacorp is the trusted partner for distressed companies. We
              deliver cost-effective turnaround strategies, cash flow solutions,
              and operational restructuring.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="/contact"
                className="px-8 py-4 bg-teal-500 text-white font-semibold rounded-full hover:bg-teal-600 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                Get a Free Assessment
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="/services"
                className="px-8 py-4 border-2 border-white text-white font-semibold rounded-full hover:bg-white hover:text-slate-900 transition-all whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                Our Services
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}